export const ExpansionPanelsNamespace = 'ExpansionPanels';
export default {
  [ExpansionPanelsNamespace]: {
    link: 'See all Billing FAQs',
    modalBackButton: 'Back',
  },
};
